<div class="app-root">
    <main class="content">
        <app-topbar></app-topbar>
        <app-layout-shell></app-layout-shell>
        <router-outlet></router-outlet>
        <footer-component *ngIf="showFooter"></footer-component>
    </main>
</div>
